import * as t from "./types";
import * as actions from "./action";

/* Kibana */
export const kibanaLoginAction = (
  payload: t.KibanaLoginRequestType
): t.KibanaLoginActionType => {
  return {
    type: actions.KIBANA_LOGIN,
    payload,
  };
};
